<template>
    <form @submit.prevent="emitSave" id="contextitemsAddEditDialog">
      <h4 class="mb-4">{{ 'ADD' | translate }}</h4>
    
      <div class="form-group" id="contextitemsAddEditDialog-formGroup-Omschrijving">
        <label>{{ 'id' | translate }}</label>
        <input type="number"
               class="form-control form-control-sm"
               v-model="contextitems.id" :disabled="edited"
               id="contextitemsAddEditDialog-formGroup-Omschrijving-input">
      </div>
      <div class="form-group" id="contextitemsAddEditDialog-formGroup-naam">
        <label>{{ 'Naam' | translate }} <span class="asterisk">*</span></label>
        <input type="text"
               class="form-control form-control-sm"
               v-model="contextitems.name"
               required
               id="contextitemsAddEditDialog-formGroup-naam-input">
      </div>
    
      <div class="form-group" id="contextitemsAddEditDialog-formGroup-Enabled">
        <label>{{ 'Enabled' | translate }}</label>
        <input type="checkbox"
               class="form-control form-control-sm"
               v-model="contextitems.enabled"
               id="contextitemsAddEditDialog-formGroup-Enabled-input">
      </div>
    
      <div class="mt-4 text-right" id="contextitemsAddEditDialog-formGroup-buttons">
    
        <button class="btn btn-link" type="button"
                @click="emitClose"
                id="contextitemsAddEditDialog-closeButton"
        >{{ 'CLOSE' | translate }}</button>
    
        <button class="btn btn-primary"
                type="submit"
                :disabled="!isFormValid"
                id="contextitemsAddEditDialog-addButton"
        >{{ 'ADD' | translate }}</button>
    
      </div>
    </form>
    </template>
    
    <script>
    import GeneralConfigService from '../../../service/GeneralConfigService';
    
    export default {
      props: [ 'edited' ],
      data() {
        return {
          contextitems: {}
        }
      },
      computed: {
        isFormValid() {
          return this.contextitems.name;
        }
      },
      methods: {
        emitSave() {
          this.$emit(this.edited ? 'update' : 'save', this.contextitems);
          if (this.contextitems.enabled) {
            GeneralConfigService.addOrUpdateEnabledContextItems(this.contextitems);
          } else {
            GeneralConfigService.removeEnabledContextItems(this.contextitems);
          }
          this.contextitems = {};
        },
        emitClose() {
          this.$emit('close');
          this.contextitems = {};
        }
      },
      watch: {
        edited(newVal, oldVal) {
          this.contextitems = {...newVal};
        }
      }
    }
    </script>
    
    <style lang="scss" scoped>
    .asterisk {
      color: $danger;
    }
    
    >>> .vdp-datepicker__calendar {
      bottom: 30px;
    }
    </style>
    


// WEBPACK FOOTER //
// src/components/admin/contextitems/ContextItemsAddEditDialog.vue